import { Directive } from '@angular/core';
import { AbstractControlBar } from './abstract-control-bar';

@Directive({})
export abstract class AbstractWidget extends AbstractControlBar {
  abstract closeWidget?(): void;
}
